module.exports = __webpack_public_path__ + "img/stickers-livret-famille.d973ba7c.jpg";